var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Overlay',{attrs:{"show":_vm.loading}},[_c('RegulationQuestions',{attrs:{"groups":_vm.groups,"legislations":_vm.legislations,"answers":_vm.answers},on:{"answersChange":function($event){return _vm.$emit('answersChange', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }